import { render, staticRenderFns } from "./NavBarOverlay.vue?vue&type=template&id=6dcaefb4&scoped=true"
import script from "./NavBarOverlay.vue?vue&type=script&lang=js"
export * from "./NavBarOverlay.vue?vue&type=script&lang=js"
import style0 from "./NavBarOverlay.vue?vue&type=style&index=0&id=6dcaefb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcaefb4",
  null
  
)

export default component.exports